import type { ThmRouteObject } from 'src/common/interfaces';
import { routeProtector } from 'src/router/route-protector';
import { rootHandle, fullScreen } from './soc-sim';
export const threatHuntingRoutes: ThmRouteObject[] = [{
  path: '/threat-hunting',
  loader: routeProtector().requireFeatureFlag('threat-hunting'),
  async lazy() {
    const {
      ThreatHunting
    } = await import('src/features/threat-hunting');
    return {
      Component: ThreatHunting
    };
  },
  children: [{
    path: '',
    async lazy() {
      const {
        ThreatHuntingPublicGuard
      } = await import('src/features/threat-hunting');
      return {
        Component: ThreatHuntingPublicGuard
      };
    },
    children: [{
      path: '',
      async lazy() {
        const {
          ThreatHuntingHome
        } = await import('src/features/threat-hunting');
        return {
          Component: ThreatHuntingHome
        };
      },
      handle: rootHandle
    }]
  }, {
    path: '',
    loader: routeProtector()
    // .requireBusinessUserOrCorporatePartner()
    .requireCompletedOnboardingAndWelcome(),
    children: [{
      // guard wrapper for routes that should not be accessible if there is an active run
      path: '',
      async lazy() {
        const {
          ThreatHuntingActiveRunGuard
        } = await import('src/features/threat-hunting');
        return {
          Component: ThreatHuntingActiveRunGuard
        };
      },
      children: [{
        path: 'scenario-onboarding',
        async lazy() {
          const {
            ScenarioOnboarding
          } = await import('src/features/threat-hunting');
          return {
            Component: ScenarioOnboarding
          };
        },
        children: [{
          path: '',
          async lazy() {
            const {
              ScenarioOnboardingFlow
            } = await import('src/features/threat-hunting');
            return {
              Component: ScenarioOnboardingFlow
            };
          },
          handle: {
            ...fullScreen,
            name: 'threat_hunting_scenario_onboarding'
          }
        }]
      }, {
        path: 'scenario-overview',
        async lazy() {
          const {
            ScenarioOverview
          } = await import('src/features/threat-hunting/scenario-overview');
          return {
            Component: ScenarioOverview
          };
        },
        children: [{
          path: '',
          async lazy() {
            const {
              ScenarioOverviewFlow
            } = await import('src/features/threat-hunting/scenario-overview');
            return {
              Component: ScenarioOverviewFlow
            };
          },
          handle: {
            ...fullScreen,
            name: 'threat_hunting_scenario_overview'
          }
        }]
      }, {
        path: 'summary/:runId',
        async lazy() {
          const {
            ThreatHuntingSummaryPage
          } = await import('src/features/threat-hunting');
          return {
            Component: ThreatHuntingSummaryPage
          };
        },
        handle: {
          ...fullScreen,
          name: 'threat_hunting_summary'
        }
      }]
    }, {
      // guard wrapper for routes that should only be accessible if there is an active run
      path: '',
      async lazy() {
        const {
          ThreatHuntingSimulator
        } = await import('src/features/threat-hunting');
        return {
          Component: ThreatHuntingSimulator
        };
      },
      children: [{
        path: 'threat-intel',
        // Threat hunting dashboard page
        async lazy() {
          const {
            ThreatIntel
          } = await import('src/features/threat-hunting');
          return {
            Component: ThreatIntel
          };
        },
        handle: {
          ...fullScreen,
          name: 'threat_hunting_threat-intel'
        }
      }, {
        path: 'my-computer',
        async lazy() {
          const {
            MyComputer
          } = await import('src/features/threat-hunting');
          return {
            Component: MyComputer
          };
        },
        handle: {
          ...fullScreen,
          name: 'threat_hunting_my_computer'
        }
      }, {
        path: 'timeline',
        async lazy() {
          const {
            Timeline
          } = await import('src/features/threat-hunting');
          return {
            Component: Timeline
          };
        },
        handle: {
          ...fullScreen,
          name: 'threat_hunting_timeline',
          hideIntercom: true
        }
      }, {
        path: 'threat-report',
        async lazy() {
          const {
            ThreatReport
          } = await import('src/features/threat-hunting');
          return {
            Component: ThreatReport
          };
        },
        handle: {
          ...fullScreen,
          name: 'threat_hunting_documentation'
        }
      }, {
        path: 'documentation',
        async lazy() {
          const {
            Documentation
          } = await import('src/features/threat-hunting');
          return {
            Component: Documentation
          };
        },
        handle: {
          ...fullScreen,
          name: 'threat_hunting_documentation'
        }
      }, {
        path: 'guide',
        async lazy() {
          const {
            Guide
          } = await import('src/features/threat-hunting');
          return {
            Component: Guide
          };
        },
        handle: {
          ...fullScreen,
          name: 'threat_hunting_guide'
        }
      }, {
        path: 'guide/:guideId',
        async lazy() {
          const {
            GuideDetails
          } = await import('src/features/threat-hunting');
          return {
            Component: GuideDetails
          };
        },
        handle: fullScreen
      }]
    }]
  }]
}];